import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { HistoryItemResponse } from '@shared/index';
import { SupervisorService } from 'src/app/routes/ai-bot/admin/tabs/insights/supervisor-tab/supervisor.service';
import { RouteShareService } from '../services/route-share.service';

export const supervisorResolver: ResolveFn<void> = async (_route, _state) => {
  const supervisorService: SupervisorService = inject(SupervisorService);
  const rss = inject(RouteShareService);
  const botId: string = rss.botConfig._id;
  // Load only the first page of threads — the table's onLazyLoad handles subsequent pages.
  await supervisorService.loadThreadsPage(botId, 0, 20);
  await supervisorService.loadSummariesForBot(botId);
  supervisorService.loadHelpRequests();
};

export const supervisorSelectResolver: ResolveFn<HistoryItemResponse[]> = async (route, _state) => {
  const supervisorService: SupervisorService = inject(SupervisorService);
  const threadId: string = route.params['thread'] + "";
  if (threadId && threadId != "") {
    await supervisorService.selectThread(threadId);
    await supervisorService.loadAdminMessages();
    await supervisorService.loadKeyVal();
  }
  supervisorService.calculateMeasurements();
  return supervisorService.historyItems;
};
